// Platform uses module scss in order to not interupt other peoples code use module based styling
// If you want to add global styles you can write it inside styles file and import it to the index.scss

import {BrowserRouter} from "react-router-dom";
import JWTAuthAuthProvider from "./auth/JWTAuthProvider";
import {App as AntdApp, ConfigProvider} from "antd";
import {QueryClient, QueryClientProvider} from "react-query";
import AppLayout from "./layouts/index";
import {LanguageProvider} from "./i18n";
import {Provider} from "react-redux";
import {store} from "./store";
import "antd/dist/reset.css";

const queryClient = new QueryClient();

function App() {
  return (
      <Provider store={store}>
      <LanguageProvider>

    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#1f6fdf",
              },
            }}
          >
            <AntdApp>
              <JWTAuthAuthProvider>
                <AppLayout />
              </JWTAuthAuthProvider>
            </AntdApp>
          </ConfigProvider>
      </BrowserRouter>
    </QueryClientProvider>
        </LanguageProvider>
      </Provider>
  );
}

export default App;
